// extracted by mini-css-extract-plugin
module.exports = {"detail_new":"styles_detail_new__1vvDy","header":"styles_header__1jJBr","back":"styles_back__1jj-8","title":"styles_title__6Gecx","content":"styles_content__36DFE"};